import { render, staticRenderFns } from "./LabNotes.vue?vue&type=template&id=3af2d511&scoped=true&"
import script from "./LabNotes.vue?vue&type=script&lang=js&"
export * from "./LabNotes.vue?vue&type=script&lang=js&"
import style0 from "./LabNotes.vue?vue&type=style&index=0&id=3af2d511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2d511",
  null
  
)

export default component.exports